


















































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import UserListBase from "./UserListBase";

	@Component
	export default class UserList extends UserListBase {

		created() {
			super.initializeRights('COR_User_Create', 'COR_User_Delete', 'COR_User_Read', 'COR_User_Update');
			super.created();
			super.setDetailName('UserDetail');
            this.setDeleteMessage(this.$t('user.messageQuestionMain').toString(), this.$t('user.messageQuestionMain2').toString(), this.$t('user.messageQuestionMain3').toString());
		};

		selectRows(items: any) {
			super.selectRows(items);
		}
		items = [];

		showAllertToDeleteClick(itemsSelected: any) {
			this.items = itemsSelected;
			//TODO pokud by to slo prenest do predka aby to fungovalo
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;

			if (this.$store.state.askBeforeDelete) {
                super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(  ), true);
				//super.showAlertBeforeActionClickBase(itemsSelected, this.$t('user.messageQuestionMain').toString(), true);
			}
			else {
				this.itemsSelected = itemsSelected;
				this.callActionClick();
            }
		}

		loadFilters(value: any) {


			super.loadFilters(value);
		};
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		deleteClick(elementId: any) { super.deleteClick(elementId); }

		detailClick(userId: any) {
			if (this.isShowModal) {
				this.$emit('selectItem', userId);
			}
			else if (this.hasRight) {
				this.$router.push({ name: "UserDetail",  query: { id: userId } });
			}
		};
	};
